import { enrichAccountInformation } from '../api/enrichAccountInformation';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';

/**
 * Initializes a service for patching the payout account number
 *
 * @returns service function for patching
 */
const useEnrichAccountInformationService = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();

    return async (payoutAccountNumber: string) => {
        if (!authenticationData) {
            throw Error('Not authenticated');
        }

        return await enrichAccountInformation(
            proxyBaseUrl,
            apiKey,
            applicationReferenceNumber,
            authenticationData,
            payoutAccountNumber,
        );
    };
};

export default useEnrichAccountInformationService;
